import PropTypes from 'prop-types';
import React from 'react';

import NormalButton from '../../atoms/NormalButton';

class ConfirmEditButton extends React.Component {
  static get propTypes() {
    return {
      children: PropTypes.any,
      onClick: PropTypes.func,
    };
  }

  render() {
    return (
      <NormalButton color="primary" onClick={this.props.onClick}>
        確定
      </NormalButton>
    );
  }
}

export default ConfirmEditButton;
